<template>
  <AppSelectListItem
    :id="selectListItemId(jobSite.id)"
    :class="{ active: isSelected(selectedSite, jobSite) }"
    @click="onItemSelect(jobSite)"
  >
    <template #label>
      <div
        :id="jobSite.id"
        class="job-site-item"
      >
        <div
          class="custom-select-list-item-avatar"
          :style="{ backgroundColor: jobSite.color }"
        >
          <img
            :src="whiteMarkerIcon"
            :alt="jobSite.name"
          />
        </div>
        <div class="job-site-item-content">
          <div class="text-overflow">
            {{ jobSite.name }}
          </div>
          <span class="hint is-regular">{{ jobSite.address }}</span>
        </div>
      </div>
    </template>
  </AppSelectListItem>
</template>

<script>
import { mapState } from 'vuex';
import { ICON_MARKER_WHITE } from '~/rails_assets';

export default {
  name: 'ActivitiesLocationSelectJobSite',
  props: {
    sidebarId: {
      type: String,
      default: null,
    },
    jobSite: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      fromSidebar: false,
      whiteMarkerIcon: ICON_MARKER_WHITE,
    };
  },
  computed: {
    ...mapState(['selectedSite']),
  },
  watch: {
    selectedSite(site) {
      if (site && !this.fromSidebar) {
        const sidebar = document.getElementById(this.sidebarId);
        const listItem = document.getElementById(this.selectListItemId(site.id));

        if (sidebar && listItem) {
          const sidebarHeightHalf = sidebar.clientHeight / 2;

          sidebar.scrollTop = listItem.offsetTop - sidebarHeightHalf;
        }
      }

      this.fromSidebar = false;
    },
  },
  methods: {
    onItemSelect(jobSite) {
      this.fromSidebar = true;
      this.$emit('job-site-selected', jobSite);
    },
    selectListItemId(id) {
      return `activities-locations-select-job-site-select-${this._uid}-list-item-${id}`;
    },
    isSelected(selected, current) {
      return !!(selected && selected.id === current.id);
    },
  },
};
</script>
